import { Controller } from "@hotwired/stimulus";

// Vérifie en direct l'accès en écriture du compte de service au dossier Google
// Drive saisi, et affiche un message d'aide (email à autoriser) si KO.
export default class extends Controller {
  static targets = ["input", "result", "button", "email"];
  static values = { url: String, email: String };

  connect() {
    this._csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";
  }

  async verify() {
    const folderId = (this.hasInputTarget ? this.inputTarget.value : "").trim();
    if (!folderId) {
      this._render("warn", "Renseignez d'abord un ID de dossier.");
      return;
    }

    this._setLoading(true);
    try {
      const resp = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this._csrf,
          Accept: "application/json",
        },
        body: JSON.stringify({ folder_id: folderId }),
      });
      const data = await resp.json();
      this._render(data.ok ? "ok" : "warn", data.message || "Vérification terminée.");
    } catch (e) {
      this._render("warn", "Vérification impossible (erreur réseau).");
    } finally {
      this._setLoading(false);
    }
  }

  copyEmail() {
    const email = this.emailValue || (this.hasEmailTarget ? this.emailTarget.textContent : "");
    if (email && navigator.clipboard) {
      navigator.clipboard.writeText(email.trim());
    }
  }

  _setLoading(on) {
    if (!this.hasButtonTarget) return;
    this.buttonTarget.disabled = on;
    this.buttonTarget.style.opacity = on ? "0.6" : "";
  }

  _render(kind, message) {
    if (!this.hasResultTarget) return;

    const color = kind === "ok" ? "#16a34a" : "#d97706";
    const bg = kind === "ok" ? "#f0fdf4" : "#fffbeb";
    const icon = kind === "ok" ? "fa-circle-check" : "fa-triangle-exclamation";
    this.resultTarget.innerHTML =
      `<div style="border:1px solid ${color};background:${bg};border-radius:10px;padding:.6rem .8rem;color:${color};">` +
      `<i class="fa-solid ${icon}" aria-hidden="true"></i> ${this._escape(message)}</div>`;
  }

  _escape(s) {
    const d = document.createElement("div");
    d.textContent = s;
    return d.innerHTML;
  }
}
